import React from 'react'

import BlockVideo from './BlockVideo'
import BlockParagraph from './BlockParagraph'
import BlockImage from './BlockImage'
import BlockGallery from './BlockGallery'

export default ({ page }) => {
  return (
    <React.Fragment>
      {page.acf.blocks_page !== null &&
        page.acf.blocks_page.map((row, index) => (
          <React.Fragment key={index}>
            {row.__typename === 'WordPressAcf_video' && (
              <BlockVideo video={row.video} />
            )}
            {row.__typename === 'WordPressAcf_paragraph' && (
              <BlockParagraph content={row.paragraph} />
            )}
            {row.__typename === 'WordPressAcf_gallery' && (
              <BlockGallery images={row.gallery} />
            )}
            {row.__typename === 'WordPressAcf_image' && (
              <BlockImage image={row.image} />
            )}
          </React.Fragment>
        ))}
    </React.Fragment>
  )
}
